import Request, { API } from '@/http/'

export function eventTrack (data) {
  const adid = localStorage.getItem('adid')
  const userRandomKey = localStorage.getItem('userRandomKey')

  const { pageName, action, extInfo } = data

  Request.getData(`${API.evnetTrack}/${pageName}/${action}`, {
    adid,
    extInfo: JSON.stringify(extInfo),
    userRandomKey
  })
}

export const $eventTrack = eventTrack
export default {
  install (Vue) {
    Vue.prototype.$eventTrack = eventTrack
  }
}
